module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('items-list', {
    staticClass: "nav-container",
    class: {
      'is-small': _vm.small
    },
    attrs: {
      "items": _vm.items,
      "level": 1,
      "max-level": _vm.maxLevel,
      "small": _vm.small,
      "compact": true
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cb98c94","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/nav/Compact.vue
// module id = bcc0429f58498c9cd694
// module chunks = 0